import identity from 'lodash/identity';
// eslint-disable-next-line no-restricted-imports
import { CSSObject, CSSProperties } from 'styled-components';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const BREAKPOINTS: Record<Breakpoint, number> = Object.freeze({
    xs: 0, // phone
    sm: 768, // tablet
    md: 900, // small laptop
    lg: 1280, // desktop
    xl: 1600,
});

export const up = (key: Breakpoint) => `@media (min-width:${BREAKPOINTS[key]}px)`;

export const down = (key: Breakpoint) => `@media (max-width:${BREAKPOINTS[key] - 1}px)`;

const isBreakpoint = (value: any): value is Breakpoint => Object.keys(BREAKPOINTS).includes(value);

export type BreakpointProp<TValue> = TValue | Partial<Record<Breakpoint, TValue>>;

export function breakpoint(
    propName: keyof CSSProperties,
    propValue: any,
    styleFromPropValue: (propValue: any) => CSSProperties[keyof CSSProperties] = identity,
): CSSObject {
    if (typeof propValue === 'object') {
        return Object.keys(propValue as any).reduce((cssObject, key) => {
            if (isBreakpoint(key)) {
                const mediaKey = up(key);
                const style = styleFromPropValue(propValue[key]);

                cssObject[mediaKey] = { [propName]: style };

                return cssObject;
            }

            cssObject[key] = propValue[key];

            return cssObject;
        }, {} as any);
    }

    return { [propName]: styleFromPropValue(propValue) };
}
